export function dropNum(num: number) {
  let str = `${num}`
  let splitIndex = (str.length + 2) % 3 + 1;
  str = str.substr(0, splitIndex) + str.substr(splitIndex).replace(/\d\d\d/g, ' $&')
  return str
}